"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
const resourceID = "sprites1";
const sprites1 = {
    resourceID,
    url: "/region1.png",
    spriteSize: 16,
    layers: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, utils_1.tileWithBorders(resourceID, "grass", { x: 1, y: 1 })), utils_1.tileWithBorders(resourceID, "grass_in", { x: 4, y: 1 })), utils_1.tileWithBorders(resourceID, "path", { x: 1, y: 4 })), utils_1.tileWithBorders(resourceID, "path_in", { x: 4, y: 4 })), utils_1.simpleRect(resourceID, "tallRise", { x: 9, y: 0 }, 3, 4)), utils_1.simpleRect(resourceID, "tallRise_in", { x: 14, y: 1 }, 2, 3)), utils_1.simpleRect(resourceID, "tallRise_in", { x: 12, y: 0 }, 2, 4)), utils_1.simpleRect(resourceID, "flowers", { x: 11, y: 5 }, 5, 3)), utils_1.simpleRect(resourceID, "maze", { x: 5, y: 7 }, 4, 5)), { water: {
            resourceID,
            layerID: "water",
            sprite: {
                x: 1,
                y: 20,
            },
        }, bigrock1: {
            resourceID,
            layerID: "bigrock1",
            sprite: {
                x: 0,
                y: 14,
            },
            size: {
                width: 2,
                height: 2,
            },
        }, bigrock2: {
            resourceID,
            layerID: "bigrock2",
            sprite: {
                x: 2,
                y: 14,
            },
            size: {
                width: 2,
                height: 2,
            },
        }, smallrock1: {
            resourceID,
            layerID: "smallrock1",
            sprite: {
                x: 4,
                y: 13,
            },
        }, smallrock2: {
            resourceID,
            layerID: "smallrock2",
            sprite: {
                x: 4,
                y: 14,
            },
        }, smallrock3: {
            resourceID,
            layerID: "smallrock3",
            sprite: {
                x: 4,
                y: 15,
            },
        }, smalltree1: {
            resourceID,
            layerID: "smalltree1",
            sprite: {
                x: 0,
                y: 11,
            },
            size: {
                width: 1,
                height: 3,
            },
        }, smalltree2: {
            resourceID,
            layerID: "smalltree2",
            sprite: {
                x: 3,
                y: 11,
            },
            size: {
                width: 1,
                height: 3,
            },
        }, mediumtree1: {
            resourceID,
            layerID: "mediumtree1",
            sprite: {
                x: 1,
                y: 11,
            },
            size: {
                width: 2,
                height: 3,
            },
        }, smallsign: {
            resourceID,
            layerID: "smallsign",
            sprite: {
                x: 0,
                y: 7,
            },
            size: {
                width: 1,
                height: 2,
            },
        } }),
};
exports.default = sprites1;
//# sourceMappingURL=region1.js.map